import React, { useState, useEffect } from 'react';
import clockOrange from '../../assets/images/clock_orange.svg';
import canceled from '../../assets/images/canceled.svg';
import Loading from '../layout/Loading';
import {
  VisitDetailsModalOverlay,
  VisitDetailsModalContainer,
  InAnalysisModalContainer,
  VisitDetailsModalHeader,
  VisitDetailsModalTitle,
  VisitDetailsCloseButton,
  VisitDetailsStatusBadge,
  InAnalysisStatusBadgeOrange,
  NotRealizedStatusBadge,
  ConfirmedInfoBox,
  ConfirmedIconContainer,
  ConfirmedMessage,
  NotRealizedInfoBox,
  NotRealizedIconContainer,
  NotRealizedMessage,
  VisitDetailsSection,
  VisitDetailsSectionTitle,
  VisitDetailsSummaryItem,
  VisitDetailsSummaryIcon,
  VisitDetailsSummaryContent,
  VisitDetailsSummaryLabel,
  VisitDetailsSummaryValue,
  VisitDetailsRatingSection,
  VisitDetailsRatingNumber,
  VisitDetailsRatingStars,
  VisitDetailsRatingText,
  VisitDetailsTag,
  EvaluationFormContainer,
  EvaluationFormTitle,
  EvaluationTextarea,
  EvaluationButtonsContainer,
  EvaluationCancelButton,
  EvaluationSubmitButton,
  VisitSummaryText,
  PlanContainer,
  PlanTitle,
  PlanText,
  PlanDivider,
  VisitTagsContainerCustom,
  VisitSectionSpaced,
  RatingStarImageClickable,
  ToggleButton,
  AttentionTitle,
  LegalText,
  EvaluationFormContentWrapper,
  EvaluationRequiredSpan,
  EvaluationTextareaWrapper,
  EvaluationCharCounterContainer,
  EvaluationValidationLeft,
  EvaluationValidationMessage,
  EvaluationCharCount,
  LoadingOverlay
} from './styles';

import starSvg from '../../assets/images/star.svg';
import { updateCommitment, postIndecxAnswer } from '~/services/commitmentService';
import { toast } from 'react-toastify';

const VisitDetailsModal = ({
  isOpen,
  onClose,
  visit,
  onAfterUpdate,
  }) => {
  const [currentRating, setCurrentRating] = useState(0);
  const [showEvaluationForm, setShowEvaluationForm] = useState(false);
  const [evaluationComment, setEvaluationComment] = useState('');
  const [hasExistingRating, setHasExistingRating] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    summary: false,
    consultorPlan: false,
    resellerPlan: false,
  });

  const charLimit = 300;

  const handleCommentChange = (e) => {
    const value = e.target.value;
    if (value.length <= charLimit) {
      setEvaluationComment(value);
    }
  };

  const isCommentRequired = currentRating <= 2;
  const isCommentValid = evaluationComment.trim().length >= 10;
  const canSubmit = currentRating > 0 && (currentRating > 2 || isCommentValid) && !isSubmitting;

  useEffect(() => {
    if (visit && visit.rating !== null && visit.rating !== undefined) {
      setCurrentRating(Number.isInteger(visit.rating) ? visit.rating : 0);
      setHasExistingRating(true);
      setShowEvaluationForm(false);
    } else {
      setCurrentRating(0);
      setHasExistingRating(false);
      setShowEvaluationForm(false);
    }
    setEvaluationComment('');
  }, [visit]);

  const handleStarClick = (starNumber) => {
    const hasCommitment = !!(visit && (visit.raw && visit.raw.commitmentId));
    if (hasExistingRating || !hasCommitment) return;
    setCurrentRating(starNumber);
    setShowEvaluationForm(true);
  };

  const handleSubmitEvaluation = async () => {
    if (isSubmitting) return;

    if (!visit || !(visit.raw && visit.raw.commitmentId)) {
      toast.error('ID da visita não disponível. Tente novamente.');
      return;
    }

    const commitmentId = visit.raw.commitmentId;

    const indecxBody = {
      inviteId: '',
      name: localStorage.getItem('userName') || '',
      email: localStorage.getItem('email') || '',
      phone: localStorage.getItem('consultantPhone') || '',
      review: Number(currentRating),
      feedback: evaluationComment && evaluationComment.trim() ? evaluationComment.trim() : undefined,
      additionalQuestions: [],
          indicators: [
            {
              column: "Nome da revenda",
              value: localStorage.getItem('storeName') || ''
            },
            {
              column: "Código de Cliente",
              value: localStorage.getItem('storeId') || ''
            },
            {
              column: "Código de Endereço",
              value: localStorage.getItem('addressId') || ''
            },
            {
              column: "Mercado",
              value: localStorage.getItem('market') || ''
            },
            {
              column: "Núcleo",
              value: localStorage.getItem('core') || ''
            },
            {
              column: "Estado",
              value: localStorage.getItem('state') || ''
            },
            {
              column: "UF",
              value: localStorage.getItem('userUf') || ''
            }
          ],
    };

    setIsSubmitting(true);
    try {
      try {
        await postIndecxAnswer(indecxBody);
      } catch (e) {
        console.warn('postIndecxAnswer failed', e);
      }

      const payload = {
        user_id: localStorage.getItem('userId') || null,
        visit_rating: Number(currentRating),
      };
      if (evaluationComment && evaluationComment.trim().length > 0) {
        payload.comment = evaluationComment.trim();
      }

      await updateCommitment(commitmentId, payload);

      setHasExistingRating(true);
      setShowEvaluationForm(false);
      toast.success('Avaliação enviada com sucesso!');

      if (typeof onClose === 'function') onClose();
      if (typeof onAfterUpdate === 'function') {
        await onAfterUpdate();
      }
    } catch (err) {
      console.warn('Erro ao enviar avaliação', err);
      toast.error('Erro ao enviar avaliação. Tente novamente.');
      setShowEvaluationForm(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancelEvaluation = () => {
    setCurrentRating(0);
    setShowEvaluationForm(false);
    setEvaluationComment('');
  };

  const toggleSection = (sectionName) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionName]: !prev[sectionName]
    }));
  };

  const formatDateWithPeriod = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split(' às ');
    if (parts.length !== 2) return dateString;

    const [date] = parts;
    return date;
  };

  const shouldShowToggle = (text) => text && text.length > charLimit;

  const renderTextWithToggle = (text, sectionName) => {
    if (!text) return text;
    const isExpanded = expandedSections[sectionName];
    const shouldShow = shouldShowToggle(text);

    return (
      <div>
        <div>
          {isExpanded ? text : shouldShow ? `${text.substring(0, charLimit)}...` : text}
        </div>
        {shouldShow && (
          <ToggleButton onClick={() => toggleSection(sectionName)}>
            {isExpanded ? 'Ver menos' : 'Ver mais'}
          </ToggleButton>
        )}
      </div>
    );
  };

  if (!isOpen || !visit.raw.StatusDaVisita) return null;

  const renderModalContent = () => {
    switch (visit.raw.StatusDaVisita) {
      case 'Agendado':
        return (
          <InAnalysisModalContainer onClick={(e) => e.stopPropagation()}>
            <VisitDetailsModalHeader>
              <VisitDetailsModalTitle>Detalhes da visita</VisitDetailsModalTitle>
              <VisitDetailsCloseButton onClick={onClose}>
                ×
              </VisitDetailsCloseButton>
            </VisitDetailsModalHeader>

            <InAnalysisStatusBadgeOrange>
              Agendado
            </InAnalysisStatusBadgeOrange>

            <ConfirmedInfoBox>
              <ConfirmedIconContainer>
                <img
                  src={clockOrange}
                  alt="Relógio"
                  width="40"
                  height="40"
                />
              </ConfirmedIconContainer>
              <ConfirmedMessage>
                Visita realizada. Prepare-se para receber<br />
                o consultor em <strong>{formatDateWithPeriod(visit.date)}</strong>.
              </ConfirmedMessage>
            </ConfirmedInfoBox>

            {renderSummarySection()}
          </InAnalysisModalContainer>
        );

      case 'Cancelado':
        return (
          <InAnalysisModalContainer onClick={(e) => e.stopPropagation()}>
            <VisitDetailsModalHeader>
              <VisitDetailsModalTitle>Detalhes da visita</VisitDetailsModalTitle>
              <VisitDetailsCloseButton onClick={onClose}>
                ×
              </VisitDetailsCloseButton>
            </VisitDetailsModalHeader>

            <NotRealizedStatusBadge>
              Cancelado
            </NotRealizedStatusBadge>

            <NotRealizedInfoBox>
              <NotRealizedIconContainer>
                <img
                  src={canceled}
                  alt="Cancelado"
                  width="40"
                  height="40"
                />
              </NotRealizedIconContainer>
              <NotRealizedMessage>
                A visita foi cancelada. Em breve será agendada uma nova visita.
              </NotRealizedMessage>
            </NotRealizedInfoBox>

            {renderSummarySection()}
          </InAnalysisModalContainer>
        );

      case 'Realizado':
      default:
        {
          const hasCommitment = !!(visit && visit.raw && visit.raw.commitmentId);
          const hasAnyRatingOrCommitment = (
            (visit && visit.rating != null) ||
            (visit && visit.raw && (
              visit.raw.commitmentId != null ||
              visit.raw.confirm != null ||
              visit.raw.finished != null
            ))
          );
          return (
          <VisitDetailsModalContainer onClick={(e) => e.stopPropagation()}>
            <VisitDetailsModalHeader>
              <VisitDetailsModalTitle>Detalhes da visita</VisitDetailsModalTitle>
              <VisitDetailsCloseButton onClick={onClose}>
                ×
              </VisitDetailsCloseButton>
            </VisitDetailsModalHeader>

            <VisitDetailsStatusBadge status={visit.raw.StatusDaVisita}>
              {visit.raw.StatusDaVisita}
            </VisitDetailsStatusBadge>


            {hasAnyRatingOrCommitment && (
              <VisitDetailsRatingSection>
              <VisitDetailsRatingNumber>
                {currentRating > 0 ? currentRating : ''}
              </VisitDetailsRatingNumber>
              <VisitDetailsRatingStars>
                {[1,2,3,4,5].map((star) => {
                  const clickable = hasCommitment && !hasExistingRating;
                  return (
                    <RatingStarImageClickable
                      key={star}
                      src={starSvg}
                      alt="Estrela"
                      width="20"
                      height="20"
                      isActive={star <= currentRating}
                      hasExistingRating={hasExistingRating}
                      onClick={clickable ? () => handleStarClick(star) : undefined}
                      aria-disabled={!clickable}
                      title={!clickable ? 'Avaliação indisponível' : `Avaliar ${star} estrela${star > 1 ? 's' : ''}`}
                      style={{ cursor: clickable ? 'pointer' : 'default', pointerEvents: clickable ? 'auto' : 'none' }}
                    />
                  );
                })}
              </VisitDetailsRatingStars>
              <VisitDetailsRatingText>
                {hasExistingRating ? 'Avaliação da visita' : (hasCommitment ? 'Clique nas estrelas para avaliar' : '')}
              </VisitDetailsRatingText>

              {visit.tags && (
                <VisitTagsContainerCustom style={{ justifyContent: 'center' }}>
                  {visit.tags.map((tag, index) => (
                    <VisitDetailsTag key={index}>
                      {tag}
                    </VisitDetailsTag>
                  ))}
                </VisitTagsContainerCustom>
              )}

              {showEvaluationForm && (
                <EvaluationFormContentWrapper>
                  <EvaluationFormTitle>
                    Comentário sobre a visita
                    {isCommentRequired && <EvaluationRequiredSpan> *</EvaluationRequiredSpan>}
                  </EvaluationFormTitle>
                  <EvaluationTextareaWrapper>
                    <EvaluationTextarea
                      value={evaluationComment}
                      onChange={handleCommentChange}
                      placeholder={isCommentRequired ? "Comentário obrigatório (mínimo 10 caracteres)" : "Digite aqui (opcional)"}
                    />
                  </EvaluationTextareaWrapper>
                  <EvaluationCharCounterContainer>
                    <EvaluationValidationLeft>
                      {isCommentRequired && evaluationComment.length > 0 && evaluationComment.length < 10 && (
                        <EvaluationValidationMessage $isError>
                          Mínimo de 10 caracteres para enviar ({evaluationComment.length}/10)
                        </EvaluationValidationMessage>
                      )}
                      {evaluationComment.length === 0 && isCommentRequired && (
                        <EvaluationValidationMessage>
                          Mínimo de 10 caracteres para enviar
                        </EvaluationValidationMessage>
                      )}
                    </EvaluationValidationLeft>
                    <EvaluationCharCount>
                      {evaluationComment.length}/{charLimit}
                    </EvaluationCharCount>
                  </EvaluationCharCounterContainer>
                  <EvaluationButtonsContainer>
                    <EvaluationCancelButton
                      onClick={handleCancelEvaluation}
                    >
                      Cancelar
                    </EvaluationCancelButton>
                    <EvaluationSubmitButton
                      onClick={handleSubmitEvaluation}
                      disabled={!canSubmit}
                    >
                      {isSubmitting ? 'Enviando...' : 'Enviar Avaliação'}
                    </EvaluationSubmitButton>
                  </EvaluationButtonsContainer>
                </EvaluationFormContentWrapper>
              )}
              </VisitDetailsRatingSection>
            )}

            {renderSummarySection()}

            {visit.raw.StatusDaVisita === 'Realizado' && (
              <>
                <VisitSectionSpaced>
                  <VisitDetailsSectionTitle>
                    Resumo da visita
                  </VisitDetailsSectionTitle>
                  <VisitSummaryText>
                    {renderTextWithToggle(
                      visit.description || (visit.raw && (visit.raw.Description || visit.raw.description)) || 'Resumo não disponível.',
                      'summary'
                    )}
                  </VisitSummaryText>
                </VisitSectionSpaced>

                <VisitSectionSpaced>
                  <VisitDetailsSectionTitle>
                    Planos de ação
                  </VisitDetailsSectionTitle>

                  <PlanContainer>
                    <PlanTitle>
                      Consultor
                    </PlanTitle>
                    <PlanText>
                      {renderTextWithToggle(
                        (visit.raw && visit.raw.PlanosDeAcaoConsultor) || 'Plano de ação não informado pelo consultor.',
                        'consultorPlan'
                      )}
                    </PlanText>

                    <PlanDivider />

                    <PlanTitle>
                      Revendedor
                    </PlanTitle>
                    <PlanText>
                      {renderTextWithToggle(
                        (visit.raw && visit.raw.PlanosDeAcaoRevendedor) || 'Plano de ação não informado pelo revendedor.',
                        'resellerPlan'
                      )}
                    </PlanText>
                  </PlanContainer>
                </VisitSectionSpaced>

                <AttentionTitle>ATENÇÃO 🚨</AttentionTitle>
                <LegalText>
                  <b>RESSALVA LEGAL: </b>
                     Os eventuais compromissos assumidos pela Ultragaz
                     nesta mensagem consideram exclusivamente o contexto atual da negociação
                     e da relação contratual entre a Ultragaz e V. Senhoria, estando
                     condicionados ao cumprimento integral de todas as obrigações assumidas por
                     V. Senhoria, seja de natureza contratual ou decorrente de outro meio.
                  <br /><br />
                  <b>AVISO DE CONFIDENCIALIDADE: </b>
                    Esta mensagem, incluindo seus anexos, contém informações confidenciais
                    destinadas exclusivamente ao responsável pelo estabelecimento comercial
                    destinatário e somente poderá ser utilizada no âmbito da relação comercial
                    existente entre a Ultragaz e V. Senhoria. É expressamente proibido o uso, acesso,
                    reprodução ou divulgação não autorizada do conteúdo desta mensagem, sob pena de
                    infração contratual. Caso você não seja o destinatário, fica desde já notificado de
                    que não poderá utilizar, copiar ou divulgar as informações aqui contidas, devendo
                    delatar a mensagem imediatamente, sob pena de responder no âmbito cível e criminal.
                </LegalText>
              </>
            )}
          </VisitDetailsModalContainer>
        );
      }
    }
  };

  const renderSummarySection = () => (
    <VisitDetailsSection>
      <VisitDetailsSectionTitle>
        Resumo
      </VisitDetailsSectionTitle>

      <VisitDetailsSummaryItem>
        <VisitDetailsSummaryIcon>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M6 2V4H14V2H16V4H18C19.1 4 20 4.9 20 6V18C20 19.1 19.1 20 18 20H2C0.9 20 0 19.1 0 18V6C0 4.9 0.9 4 2 4H4V2H6ZM18 8H2V18H18V8Z" fill="#636363"/>
          </svg>
        </VisitDetailsSummaryIcon>
        <VisitDetailsSummaryContent>
          <VisitDetailsSummaryLabel>Data da visita</VisitDetailsSummaryLabel>
          <VisitDetailsSummaryValue>
            {formatDateWithPeriod(visit.date)}
          </VisitDetailsSummaryValue>
        </VisitDetailsSummaryContent>
      </VisitDetailsSummaryItem>

      <VisitDetailsSummaryItem>
        <VisitDetailsSummaryIcon>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12 2C13.1 2 14 2.9 14 4V5H16C17.1 5 18 5.9 18 7V17C18 18.1 17.1 19 16 19H4C2.9 19 2 18.1 2 17V7C2 5.9 2.9 5 4 5H6V4C6 2.9 6.9 2 8 2H12ZM12 4H8V7H12V4ZM16 7H4V17H16V7Z" fill="#636363"/>
          </svg>
        </VisitDetailsSummaryIcon>
        <VisitDetailsSummaryContent>
          <VisitDetailsSummaryLabel>Assunto</VisitDetailsSummaryLabel>
          <VisitDetailsSummaryValue>
            {visit.raw.StatusDaVisita === 'Agendada' || visit.raw.StatusDaVisita === 'Cancelado'
              ? visit.subject || 'Treinamento da equipe'
              : visit.subject ? visit.subject.replace('\n', ' / ') : 'Treinamento da equipe'
            }
          </VisitDetailsSummaryValue>
        </VisitDetailsSummaryContent>
      </VisitDetailsSummaryItem>

      <VisitDetailsSummaryItem>
        <VisitDetailsSummaryIcon>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="#636363"/>
          </svg>
        </VisitDetailsSummaryIcon>
        <VisitDetailsSummaryContent>
          <VisitDetailsSummaryLabel>Nome do consultor</VisitDetailsSummaryLabel>
          <VisitDetailsSummaryValue>
            {visit.consultant || localStorage.getItem('consultantName')}
          </VisitDetailsSummaryValue>
        </VisitDetailsSummaryContent>
      </VisitDetailsSummaryItem>
    </VisitDetailsSection>
  );

  return (
    <VisitDetailsModalOverlay onClick={onClose}>
      {renderModalContent()}
      {isSubmitting && (
        <LoadingOverlay>
          <Loading />
        </LoadingOverlay>
      )}
    </VisitDetailsModalOverlay>
  );
};

export default VisitDetailsModal;
